import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import {  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SortingTypes } from 'sharedweb/app.structs';
import { SharedUtils } from 'sharedweb/helpers/shared.utilities';
import { UccAccountObj, UccDetailsResponse } from 'src/app/app.interfaces';

@Component({
  selector: 'app-ucc-selection',
  templateUrl: './ucc-selection.component.html',
  styleUrls: ['./ucc-selection.component.scss']
})
export class UccSelectionComponent implements AfterViewInit{
  uccSelection: string ;
  phoneNumber: string;
  uccData: UccDetailsResponse[];
  isSislWealth: boolean = false;
  @ViewChild('radioGroupContainer') radioGroupContainer: ElementRef;


  constructor (
    private dialogRef: MatDialogRef<UccSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: UccAccountObj,
  ) {
    this.uccData = this.dialogData.ucc_details.sort(SharedUtils.sortByKey('ucc', SortingTypes.Ascending));
    this.uccSelection = this.dialogData?.editUcc ?? this.uccData[0]?.ucc;
    this.isSislWealth = this.dialogData?.isSislWealth ?? false;
    if(!this.isSislWealth) {
      this.phoneNumber = this.dialogData.identifier.substring(6);
    }
  }
  ngAfterViewInit() {
    this.scrollToSelected();
  }

  /* This function ensures that the previously selected UCC is visible when the UCC selection dialog is opened.
   If a UCC was previously selected, it will automatically scroll to bring that selected UCC radio button into view */
  scrollToSelected() {
    // Find the index of the previously selected UCC
    const selectedIndex = this.uccData.findIndex(item => item.ucc === this.dialogData.editUcc);
    if (selectedIndex > -1 && this.radioGroupContainer) {
      const radioButtons = this.radioGroupContainer.nativeElement.querySelectorAll('mat-radio-button');
      // Scrolling to the radio button corresponding to the previously selected UCC
      if (radioButtons[selectedIndex]) {
        radioButtons[selectedIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
  submitUcc() {
    this.dialogRef.close([this.uccSelection, false]);
  }

  changeNumber() {
    this.dialogRef.close([this.uccSelection, true]);
  }

}
